const namespace = 'FolderTree';

export const FETCH_FOLDER_TREE_REQUEST = `${namespace}/FETCH_FOLDER_TREE_REQUEST`;
export const FETCH_FOLDER_TREE_SUCCESS = `${namespace}/FETCH_FOLDER_TREE_SUCCESS`;
export const FETCH_FOLDER_TREE_FAILURE = `${namespace}/FETCH_FOLDER_TREE_FAILURE`;
export const SET_FOLDER_TREE = `${namespace}/SET_FOLDER_TREE`;
export const SET_ACTIVE_FOLDER = `${namespace}/SET_ACTIVE_FOLDER`;
